import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService} from './base.service';
import {map} from 'rxjs/operators';
import {SelectDataModel} from '../models/selectData.model';
import {AtelierModel} from '../models/atelier.model';
import {AtelierMachines} from '../models/machine/atelier-machines.model';
import {PosteResponsableModel} from '../models/posteResponsable.model';
import {PosteDeTravailModel} from '../models/posteDeTravail.model';
import { BusinessUnitModel } from '../models/businessUnit';

@Injectable({providedIn: 'root'})
export class ListeService extends BaseService {

  getListPreparateur(idBusinessUnit): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/preparateurs/' + idBusinessUnit).pipe(
      map(item => {
        return item as Array<SelectDataModel>
      }),
    );
  }
  getListAllPreparateur(): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/Allpreparateurs/').pipe(
      map(item => {
        return item as Array<SelectDataModel>
      }),
    );
  }
  getListPreparateurFromUsines(pListUsines): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'liste/preparateurs', pListUsines).pipe(
      map(item => {
        return item as Array<SelectDataModel>
      }),
    );
  }

  getListStatus(): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/status/').pipe(
      map(item => {
        return item as Array<SelectDataModel>
      }),
    );
  }

  getListUsines(): Observable<Array<SelectDataModel<BusinessUnitModel>>> {
    return this.get(environment.apiPath + 'liste/usines/').pipe(
      map(item => {
        return item as Array<SelectDataModel<BusinessUnitModel>>;
      }),
    );
  }

  getListPosteResponsable(idUsine): Observable<Array<PosteResponsableModel>> {
    return this.get(environment.apiPath + 'posteResponsable/get/' + idUsine).pipe(
      map(item => {
        return item as Array<PosteResponsableModel>;
      }),
    );
  }

  getListPosteResponsableFromUsines(pListUsines): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'posteResponsable/fromUsines/', pListUsines).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getListPosteTravailFromUsines(pListUsines): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'posteTravail/fromUsines/', pListUsines).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getAllPosteResponsables(): Observable<Array<PosteResponsableModel>> {
    return this.post(environment.apiPath + 'posteResponsable/list/', {}).pipe(
      map(item => {
        return item as Array<PosteResponsableModel>;
      }),
    );
  }

  getAllPosteDeTravail(): Observable<Array<PosteDeTravailModel>> {
    return this.post(environment.apiPath + 'posteTravail/list/', {}).pipe(
      map(item => {
        return item as Array<PosteDeTravailModel>;
      }),
    );
  }

  getListAtelier(idUsine: number): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/ateliers/' + idUsine).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getListAtelierFromUsines(pFilter): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'liste/ateliers', pFilter).pipe(
      map(item => {
        return item as Array<SelectDataModel>
      }),
    );
  }
  getListRevision(idUsine): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/revision/' + idUsine).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getListRevisionFromUsines(pListUsines): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'liste/revision', pListUsines).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getListPriorite(idUsine): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/priorite/' + idUsine).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getListPrioriteFromUsines(pListUsines): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'liste/priorite', pListUsines).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  getListPostTravail(idUsine): Observable<Array<SelectDataModel>> {
    return this.get(environment.apiPath + 'liste/posteTravail/' + idUsine).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }
  getListPostTravailFromUsines(pListUsines): Observable<Array<SelectDataModel>> {
    return this.post(environment.apiPath + 'liste/posteTravail', pListUsines).pipe(
      map(item => {
        return item as Array<SelectDataModel>;
      }),
    );
  }

  public getListMachinesSub(idUsine: number): Observable<Array<AtelierMachines>> {
    return this.get(environment.apiPath + 'liste/listeMachinesSub/' + idUsine).pipe(
      map(item => {
        return item as Array<AtelierMachines>;
      }));
  }

  public getSafeAteliers(): Observable<Array<AtelierModel>> {
    return this.get(environment.apiPath + 'liste/safeateliers/').pipe(
      map(item => {
        return item as Array<AtelierModel>;
      }));
  }

  public getListApplication(): Observable<string[]> {
    return this.get(environment.apiPath + 'document/listVersion').pipe(
      map(item => {
        return item as string[];
      }));
  }

  public downloadVersion(version: string): Observable<Blob> {
    return this.http.get(environment.apiPath + `document/download/${version}`, {
      responseType: 'blob',
    });
  }

}
